module.exports = __webpack_public_path__ + "static/media/arrow-up.84ac61f0.png";